export default "__VITE_ASSET__DFtsMq6U__"